import { useCallback } from 'react'

const useAddChildHandler = ({
  addFindFlowOverlay,
  addParentFirstDialog,
  dupeCheckConfirmationOverlay,
  loggedUserIsPof,
  preferredSpouse,
  seenDupeCheckModal,
  setOtherRelatedParent,
  setSeenDupeCheckModal,
  setSpouseNotChild,
  spouses,
  whoIsParentOverlay,
}) => {
  const addChildHandler = useCallback(() => {
    setSpouseNotChild(false)
    if (spouses.length > 1) {
      whoIsParentOverlay.handleClick()
    } else if (!spouses.length) {
      addParentFirstDialog.handleClick()
    } else {
      setOtherRelatedParent(preferredSpouse)
      addFindFlowOverlay.handleClick()
    }
    // Opens an instructional modal over top of Add Child in certain cases
    if (!loggedUserIsPof && !seenDupeCheckModal) {
      setSeenDupeCheckModal()
      dupeCheckConfirmationOverlay.handleClick()
    }
  }, [
    addFindFlowOverlay,
    addParentFirstDialog,
    dupeCheckConfirmationOverlay,
    loggedUserIsPof,
    preferredSpouse,
    seenDupeCheckModal,
    setOtherRelatedParent,
    setSeenDupeCheckModal,
    setSpouseNotChild,
    spouses,
    whoIsParentOverlay,
  ])

  return addChildHandler
}

export default useAddChildHandler
